import { useEffect } from "react";
import { supabase } from "../lib/supabaseClient";
import { useNavigate } from "react-router-dom";

function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    async function handleOAuthCallback() {
      const { error } = await supabase.auth.exchangeCodeForSession(
        window.location.href,
      );
      if (error) {
        console.error("Error exchanging code:", error);
        navigate("/login");
      } else {
        // Redirect to dashboard after successful OAuth
        navigate("/dashboard", { replace: true });
      }
    }
    handleOAuthCallback();
  }, [navigate]);

  return <p>Signing you in...</p>;
}

export default AuthCallback;
